import "../../Css/Tutorial/TutorialDemoBanner.css";
import { TUTORIAL_SCENARIO } from "../../Constants/tutorialScenario";

type TutorialDemoBannerProps = {
  /** Short context, e.g. "Hotlist". Use "entire App Guide" for the global banner. */
  areaLabel: string;
};

export function TutorialDemoBanner({ areaLabel }: TutorialDemoBannerProps) {
  const isGlobal = areaLabel === "entire App Guide";

  return (
    <div className="tutorialDemoBanner" role="status" aria-live="polite">
      <span className="tutorialDemoBanner_icon" aria-hidden>
        <i className="fa-solid fa-flask" />
      </span>
      <div className="tutorialDemoBanner_text">
        <p className="tutorialDemoBanner_title">
          {isGlobal
            ? `Sample workspace — ${TUTORIAL_SCENARIO.clientLabel}`
            : "Sample data for App Guide"}
        </p>
        <p className="tutorialDemoBanner_body">
          {isGlobal ? (
            <>
              This tour uses a read-only snapshot of {TUTORIAL_SCENARIO.clientLabel}&apos;s
              portfolio (accounts like {TUTORIAL_SCENARIO.primaryAccount.shortName}, insights,
              and outreach examples). Your live data is not changed — once accounts and
              insights are configured, you&apos;ll see your own rows here.
            </>
          ) : (
            <>
              Example {areaLabel} from the {TUTORIAL_SCENARIO.clientLabel} tour snapshot —
              not your live workspace.
            </>
          )}
        </p>
      </div>
    </div>
  );
}
